import { CALL_ACCOUNT_SYSTEM_API } from '../../middleware/authHeaders'
import { ACCOUNT_SYSTEM_API_ROOT } from '../../config/api'

// Action types
export const SSO_CREATE_TICKET_REQUEST = 'SSO_CREATE_TICKET_REQUEST'
export const SSO_CREATE_TICKET_SUCCESS = 'SSO_CREATE_TICKET_SUCCESS'
export const SSO_CREATE_TICKET_FAILURE = 'SSO_CREATE_TICKET_FAILURE'

// Action creators
export const createSelfServiceSSOTicket =
  ({ selfServiceProfileId, connectionName, enabledClientIds, enabledOrganizationIds }) =>
  dispatch => {
    const endpoint = `${ACCOUNT_SYSTEM_API_ROOT}/v2/sso/ticket`

    const body = {
      selfServiceProfileId,
      connectionName,
      enabledClientIds,
      enabledOrganizationIds,
    }

    return dispatch({
      [CALL_ACCOUNT_SYSTEM_API]: {
        method: 'POST',
        endpoint,
        body: JSON.stringify(body),
        types: [SSO_CREATE_TICKET_REQUEST, SSO_CREATE_TICKET_SUCCESS, SSO_CREATE_TICKET_FAILURE],
      },
    })
  }

// Action creators
export const createSelfServiceSSOTicketForUpdate =
  ({ selfServiceProfileId, connectionId, enabledClientIds, enabledOrganizationIds }) =>
  dispatch => {
    const endpoint = `${ACCOUNT_SYSTEM_API_ROOT}/v2/sso/ticket/update`

    const body = {
      selfServiceProfileId,
      connectionId,
      enabledClientIds,
      enabledOrganizationIds,
    }

    return dispatch({
      [CALL_ACCOUNT_SYSTEM_API]: {
        method: 'POST',
        endpoint,
        body: JSON.stringify(body),
        types: [SSO_CREATE_TICKET_REQUEST, SSO_CREATE_TICKET_SUCCESS, SSO_CREATE_TICKET_FAILURE],
      },
    })
  }

// STATE
const SELF_SERVE_SSO_INITIAL_STATE = {
  isLoading: false,
  error: null,
  ticket: null,
}

// SELECTORS
export const selectSelfServiceSSOTicket = state => state.selfServiceSSO.ticket
export const selectSelfServiceSSOLoading = state => state.selfServiceSSO.isLoading
export const selectSelfServiceSSOError = state => state.selfServiceSSO.error

// REDUCER
const selfServiceSSO = (state = SELF_SERVE_SSO_INITIAL_STATE, { type, payload } = {}) =>
  ({
    [SSO_CREATE_TICKET_REQUEST]: current => ({
      ...current,
      isLoading: true,
      error: null,
      ticket: null,
    }),
    [SSO_CREATE_TICKET_SUCCESS]: (current, newTicket) => ({
      ...current,
      isLoading: false,
      ticket: newTicket,
    }),
    [SSO_CREATE_TICKET_FAILURE]: (current, errorPayload) => ({
      ...current,
      isLoading: false,
      ticket: null,
      error: errorPayload,
    }),
  }[type]?.(state, payload) || state)

export default selfServiceSSO
